import { Injectable, OnDestroy } from '@angular/core';
import { Router, Event as RouterEvent, NavigationEnd, NavigationCancel } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthenticationService } from '../_services/authentication.service';

/**
 * Handles the case where an authenticated user is redirected to login with returnUrl
 * due to guard failure. Redirects to root to avoid infinite loops.
 */
@Injectable({ providedIn: 'root' })
export class NavigationErrorHandler implements OnDestroy {
  private _routeListener: Subscription;

  constructor(
    private _router: Router,
    private _authService: AuthenticationService
  ) {
    this._routeListener = this._router.events.subscribe((event: RouterEvent) => {
      if (event instanceof NavigationEnd || event instanceof NavigationCancel) {
        const currentUrl = this._router.url;
        if (currentUrl.includes('/login') && currentUrl.includes('returnUrl')) {
          setTimeout(() => {
            if (this._authService.isLoggedIn && this._router.url.includes('/login') && this._router.url.includes('returnUrl')) {
              this._router.navigate(['/'], { replaceUrl: true });
            }
          }, 100);
        }
      }
    });
  }

  ngOnDestroy(): void {
    if (this._routeListener) {
      this._routeListener.unsubscribe();
    }
  }
}
